// Generated code; do not edit.
// You might be looking for: packages/bank-schemas/bank.graphql
// To regenerate: yarn workspaces foreach -A run generate-types

import type * as Types from './gqltypes';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type EmployeeFragment = {
  readonly __typename: 'Agent';
  readonly fid: string;
  readonly avatarId: Types.AvatarId;
  readonly email: string | null;
  readonly mobileNumber: string | null;
  readonly state: Types.AgentState;
  readonly type: Types.AgentType;
  readonly structuredName: {
    readonly __typename: 'Name';
    readonly full: string;
    readonly first: string | null;
    readonly legal: string | null;
  };
  readonly latestPromotion: {
    readonly __typename: 'Promotion';
    readonly fid: string;
    readonly state: Types.PromotionState;
    readonly fromType: Types.AgentType | null;
    readonly toType: Types.AgentType;
    readonly initiatedBy: {
      readonly __typename: 'Agent';
      readonly fid: string;
      readonly structuredName: {
        readonly __typename: 'Name';
        readonly full: string;
      };
    };
  } | null;
  readonly signingJobs: ReadonlyArray<{
    readonly __typename: 'SigningJob';
    readonly type: Types.SigningType;
    readonly url: string | null;
  }>;
  readonly cardAccount: {
    readonly __typename: 'CardAccount';
    readonly accountNumber: string;
    readonly account: {
      readonly __typename: 'Account';
      readonly accountNumber: string;
      readonly balanceNok: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
      readonly autofill: {
        readonly __typename: 'Autofill';
        readonly desiredAmount: string;
        readonly lowLimit: string;
        readonly dailyLimit: string;
        readonly isDailyLimitReached: boolean;
      } | null;
    };
    readonly card: {
      readonly __typename: 'Card';
      readonly fid: string;
      readonly lastFourDigits: string | null;
      readonly state: Types.CardState;
      readonly expirationYear: number;
      readonly expirationMonth: number;
    } | null;
  } | null;
};

export type FirstPaintQueryVariables = Types.Exact<{ [key: string]: never }>;

export type FirstPaintQuery = {
  readonly __typename: 'Query';
  readonly me: {
    readonly __typename: 'Agent';
    readonly spvClearance: boolean;
    readonly hasCertificateInfoInSession: boolean;
    readonly capabilities: ReadonlyArray<Types.AgentCapability>;
    readonly fid: string;
    readonly avatarId: Types.AvatarId;
    readonly email: string | null;
    readonly mobileNumber: string | null;
    readonly state: Types.AgentState;
    readonly type: Types.AgentType;
    readonly latestPromotion: {
      readonly __typename: 'Promotion';
      readonly fid: string;
      readonly state: Types.PromotionState;
      readonly fromType: Types.AgentType | null;
      readonly toType: Types.AgentType;
      readonly showInfoAboutChanges: boolean;
      readonly signing: {
        readonly __typename: 'SigningJob';
        readonly type: Types.SigningType;
        readonly url: string | null;
      } | null;
      readonly initiatedBy: {
        readonly __typename: 'Agent';
        readonly fid: string;
        readonly structuredName: {
          readonly __typename: 'Name';
          readonly full: string;
        };
      };
    } | null;
    readonly cardAccount: {
      readonly __typename: 'CardAccount';
      readonly accountNumber: string;
      readonly card: {
        readonly __typename: 'Card';
        readonly fid: string;
        readonly expirationMonth: number;
        readonly expirationYear: number;
        readonly lastFourDigits: string | null;
        readonly state: Types.CardState;
      } | null;
      readonly notActivatedCard: {
        readonly __typename: 'Card';
        readonly fid: string;
        readonly expirationMonth: number;
        readonly expirationYear: number;
        readonly state: Types.CardState;
        readonly orderedAt: string | null;
      } | null;
      readonly account: {
        readonly __typename: 'Account';
        readonly accountNumber: string;
        readonly balanceNok: {
          readonly __typename: 'AmountInfo';
          readonly asNumber: number;
        } | null;
        readonly autofill: {
          readonly __typename: 'Autofill';
          readonly desiredAmount: string;
          readonly lowLimit: string;
          readonly dailyLimit: string;
          readonly isDailyLimitReached: boolean;
        } | null;
      };
    } | null;
    readonly activeHints: ReadonlyArray<{
      readonly __typename: 'AgentHint';
      readonly kind: Types.AgentHintKind;
      readonly dismissable: boolean;
      readonly targets: ReadonlyArray<Types.Target>;
    }>;
    readonly structuredName: {
      readonly __typename: 'Name';
      readonly full: string;
      readonly first: string | null;
      readonly legal: string | null;
    };
    readonly signingJobs: ReadonlyArray<{
      readonly __typename: 'SigningJob';
      readonly type: Types.SigningType;
      readonly url: string | null;
    }>;
  };
  readonly organization: {
    readonly __typename: 'Organization';
    readonly orgNum: string;
    readonly name: string;
    readonly state: Types.OrgState;
    readonly kycStatus: Types.KycStatus;
    readonly accountingSystemInfo: {
      readonly __typename: 'AccountingSystemInfo';
      readonly systemId: Types.AccountingSystem;
    };
    readonly operationalAccount: {
      readonly __typename: 'Account';
      readonly accountNumber: string;
      readonly iban: string | null;
      readonly name: string;
      readonly balanceNok: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
    } | null;
    readonly subscriptionInformation: {
      readonly __typename: 'SubscriptionInformation';
      readonly fid: string;
      readonly overdueInvoiceDetails: {
        readonly __typename: 'OverdueInvoiceDetails';
        readonly overdueInvoiceCount: number;
        readonly notificationStage: number;
      } | null;
    } | null;
  };
  readonly accountsInfo: {
    readonly __typename: 'AccountsInfo';
    readonly accounts: ReadonlyArray<{
      readonly __typename: 'Account';
      readonly state: Types.AccountState;
      readonly type: Types.AccountType;
      readonly name: string;
      readonly iban: string | null;
      readonly accountNumber: string;
      readonly accruedInterest: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
      readonly cards: ReadonlyArray<{
        readonly __typename: 'Card';
        readonly fid: string;
        readonly state: Types.CardState;
        readonly expirationYear: number;
        readonly expirationMonth: number;
      }>;
      readonly balanceNok: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
      readonly autofill: {
        readonly __typename: 'Autofill';
        readonly desiredAmount: string;
        readonly lowLimit: string;
        readonly dailyLimit: string;
        readonly isDailyLimitReached: boolean;
      } | null;
    }>;
  };
};

export type FirstPaintNoOrgQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type FirstPaintNoOrgQuery = {
  readonly __typename: 'Query';
  readonly agent: {
    readonly __typename: 'AgentAbstraction';
    readonly free: {
      readonly __typename: 'FreeAgent';
      readonly capabilities: ReadonlyArray<Types.AgentCapability>;
      readonly fid: string;
      readonly structuredName: {
        readonly __typename: 'Name';
        readonly full: string;
        readonly first: string | null;
      };
    };
  };
  readonly organizations: {
    readonly __typename: 'Organizations';
    readonly availableOrgs: ReadonlyArray<{
      readonly __typename: 'Organization';
      readonly orgNum: string;
      readonly name: string;
      readonly state: Types.OrgState;
      readonly isInSession: boolean;
    }>;
  };
};

export type BroadcastFieldsFragment = {
  readonly __typename: 'Broadcast';
  readonly fid: string;
  readonly heading: string | null;
  readonly message: string;
  readonly scopes: ReadonlyArray<Types.BroadcastScope>;
  readonly severity: Types.BroadcastSeverity;
};

export type FirstPaintNoSessionQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type FirstPaintNoSessionQuery = {
  readonly __typename: 'Query';
  readonly enabledFeatureToggles: ReadonlyArray<string>;
  readonly broadcast: ReadonlyArray<{
    readonly __typename: 'Broadcast';
    readonly fid: string;
    readonly heading: string | null;
    readonly message: string;
    readonly scopes: ReadonlyArray<Types.BroadcastScope>;
    readonly severity: Types.BroadcastSeverity;
  }>;
  readonly simpleUserInfo: {
    readonly __typename: 'SimpleUserInfo';
    readonly isLoggedIn: boolean;
    readonly structuredName: {
      readonly __typename: 'Name';
      readonly full: string;
      readonly first: string | null;
    } | null;
  };
  readonly versions: {
    readonly __typename: 'Versions';
    readonly webVersion: string;
  };
};

export type AutofillDataFragment = {
  readonly __typename: 'Account';
  readonly accountNumber: string;
  readonly balanceNok: {
    readonly __typename: 'AmountInfo';
    readonly asNumber: number;
  } | null;
  readonly autofill: {
    readonly __typename: 'Autofill';
    readonly desiredAmount: string;
    readonly lowLimit: string;
    readonly dailyLimit: string;
    readonly isDailyLimitReached: boolean;
  } | null;
};

export type PriceFragment = {
  readonly __typename: 'Price';
  readonly amountExcludingVat: {
    readonly __typename: 'AmountInfo';
    readonly asNumber: number;
  };
  readonly amountIncludingVat: {
    readonly __typename: 'AmountInfo';
    readonly asNumber: number;
  };
  readonly vat: {
    readonly __typename: 'AmountInfo';
    readonly asNumber: number;
  };
};

export const AutofillDataFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutofillData' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Account' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'balanceNok' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'asNumber' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autofill' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'desiredAmount' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'lowLimit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dailyLimit' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isDailyLimitReached' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AutofillDataFragment, unknown>;
export const EmployeeFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Employee' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Agent' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'structuredName' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'full' } },
                { kind: 'Field', name: { kind: 'Name', value: 'first' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legal' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mobileNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestPromotion' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fromType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'initiatedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'structuredName' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'full' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signingJobs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cardAccount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'account' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutofillData' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastFourDigits' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expirationYear' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expirationMonth' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EmployeeFragment, unknown>;
export const BroadcastFieldsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'broadcastFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Broadcast' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scopes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BroadcastFieldsFragment, unknown>;
export const PriceFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'price' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Price' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'amountExcludingVat' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'asNumber' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'amountIncludingVat' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'asNumber' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vat' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'asNumber' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PriceFragment, unknown>;
export const FirstPaintDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FirstPaint' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'Employee' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'spvClearance' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hasCertificateInfoInSession' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'latestPromotion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fromType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'toType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'signing' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'showInfoAboutChanges' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'capabilities' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cardAccount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountNumber' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'card' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fid' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'expirationMonth' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'expirationYear' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notActivatedCard' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fid' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'expirationMonth' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'expirationYear' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'state' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'orderedAt' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeHints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissable' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'targets' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organization' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orgNum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountingSystemInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'systemId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operationalAccount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountNumber' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'iban' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'balanceNok' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'asNumber' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subscriptionInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'overdueInvoiceDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'overdueInvoiceCount',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'notificationStage',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'kycStatus' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountsInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'iban' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accruedInterest' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'asNumber' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AutofillData' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cards' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fid' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'state' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'expirationYear' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'expirationMonth' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...EmployeeFragmentDoc.definitions,
    ...AutofillDataFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<FirstPaintQuery, FirstPaintQueryVariables>;
export const FirstPaintNoOrgDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FirstPaintNoOrg' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'agent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'free' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'capabilities' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'structuredName' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'full' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'first' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availableOrgs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orgNum' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isInSession' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FirstPaintNoOrgQuery,
  FirstPaintNoOrgQueryVariables
>;
export const FirstPaintNoSessionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FirstPaintNoSession' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'broadcast' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'broadcastFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'simpleUserInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLoggedIn' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'structuredName' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'full' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'first' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'versions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'webVersion' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enabledFeatureToggles' },
          },
        ],
      },
    },
    ...BroadcastFieldsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  FirstPaintNoSessionQuery,
  FirstPaintNoSessionQueryVariables
>;
